import { render, staticRenderFns } from "./ChartLegend.vue?vue&type=template&id=019f7f28&scoped=true&"
import script from "./ChartLegend.vue?vue&type=script&lang=js&"
export * from "./ChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegend.vue?vue&type=style&index=0&id=019f7f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f7f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
